import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Mujeres entre 38 y 55 años que notan que su grasa se concentra solo en el abdomen.', 'Latinas que aman su comida pero quieren aprender a prepararla sin inflamarse.', 'Mujeres que sufren de digestión lenta, gases y pesadez constante.', 'Aquellas que buscan una solución práctica, rápida y sin suplementos caros.'];
  const isNotFor = ['Personas que buscan fármacos o pastillas milagrosas para "quemar grasa" sin cambiar hábitos.', 'Hombres o mujeres jóvenes que no tienen los retos hormonales de la madurez.', 'Personas que no están dispuestas a seguir una guía sencilla por al menos 14 días.'];
  return <section className="section-container" data-id="element-184">
      <div className="max-w-5xl mx-auto" data-id="element-185">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-186">
          {/* Who is for */}
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-soft border-t-8 border-sage-dark" data-id="element-187">
            <h3 className="text-2xl font-bold mb-8 text-charcoal-dark text-center" data-id="element-188">
              Este protocolo ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-189">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-190">
                  <CheckCircle2 className="w-6 h-6 text-sage-dark flex-shrink-0 mt-1" data-id="element-191" />
                  <span className="text-lg text-charcoal-light" data-id="element-192">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who is not for */}
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-soft border-t-8 border-red-400" data-id="element-193">
            <h3 className="text-2xl font-bold mb-8 text-charcoal-dark text-center" data-id="element-194">
              Este protocolo NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-195">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-196">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-197" />
                  <span className="text-lg text-charcoal-light" data-id="element-198">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}